export default "__VITE_ASSET__Djoug6Sx__"